import { isChromiumBrowser } from 'lib/utils';

isChromiumBrowser() && document.documentElement.classList.add('chromium');
